import { createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';

import {
  NullableString, RFQEntity
} from '../../interfaces';
import { RootState } from '../../store';

export interface QuoteStepProps {
    isLIVEVisible: boolean;
    lineItemRelation: RFQEntity|null;
    externalIdToOpen: NullableString;
    versionToOpen: number|null;
    externalIdToBeSaved: NullableString;
    filename: NullableString;
    dataAsCSV: NullableString;
}

const initialState: QuoteStepProps = {
    isLIVEVisible: false,
    lineItemRelation: null,
    externalIdToOpen: null,
    versionToOpen: null,
    externalIdToBeSaved: null,
    filename: null,
    dataAsCSV: ""
}

const quoteStepSlice = createSlice({
  name: "quoteStep",
  initialState,
  reducers: {
    setIsLIVEVisible(state, action: PayloadAction<boolean>) {
      state.isLIVEVisible = action.payload;
    },
    setLineItemRelation(state, action: PayloadAction<RFQEntity | null>) {
      state.lineItemRelation = action.payload;
    },
    setExternalIdToOpen(state, action: PayloadAction<NullableString>) {
      state.externalIdToOpen = action.payload;
    },
    setVersionToOpen(state, action: PayloadAction<number>) {
      state.versionToOpen = action.payload
    },
    setExternalIdToBeSaved(state, action: PayloadAction<NullableString>) {
      state.externalIdToBeSaved = action.payload;
    },
    setFilename(state, action: PayloadAction<NullableString>) {
      state.filename = action.payload;
    },
    setDataAsCSV(state, action: PayloadAction<NullableString>) {
      state.dataAsCSV = action.payload;
    },
  },
});

export const {
    setIsLIVEVisible,
    setLineItemRelation,
    setExternalIdToOpen,
    setVersionToOpen,
    setExternalIdToBeSaved,
    setFilename,
    setDataAsCSV
} = quoteStepSlice.actions;

export const selectIsLIVEVisible = (state: RootState): boolean => {
  return state.quoteStep.isLIVEVisible;
}

export const selectLineItemRelation = (state: RootState): RFQEntity | null => {
  return state.quoteStep.lineItemRelation;
}

export const selectExternalIdToOpen = (state: RootState): NullableString => {
  return state.quoteStep.externalIdToOpen;
}

export const selectVersionToOpen = (state: RootState) => {
  return state.quoteStep.versionToOpen;
}

export const selectExternalIdToBeSaved = (state: RootState): NullableString => {
  return state.quoteStep.externalIdToBeSaved;
}

export const selectFilename = (state: RootState) => {
  return state.quoteStep.filename;
}

export const selectDataAsCSV= (state: RootState) => {
  return state.quoteStep.dataAsCSV;
}

export default quoteStepSlice.reducer;
